import { CustomToastComponent } from "@/components/shared";
import {
  DeleteSheetAgentRunDocument,
  DeleteSheetAgentRunMutation,
  DeleteSheetAgentRunMutationVariables,
  GetSheetAgentRunsByTenderIdDocument,
} from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

/**
 * Custom hook for deleting a sheet agent run and handling the necessary cache updates.
 * @returns {Object} - Contains the deleteSheetAgentRunMutation function, loading state, and error state.
 */
export default function useDeleteSheetAgentRunMutationHook(): {
  deleteSheetAgentRunMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [deleteSheetAgentRunMutation, { loading, error }] = useMutation<
    DeleteSheetAgentRunMutation,
    DeleteSheetAgentRunMutationVariables
  >(DeleteSheetAgentRunDocument, {
    onCompleted() {
      toast(CustomToastComponent, {
        toastId: "sheet-agent-run-deleted-success",
        data: {
          title: t("toasts.sheetagentrundeletedsuccessfully"),
          type: "success",
        },
      });
    },
    refetchQueries: tenderID
      ? [
        {
          query: GetSheetAgentRunsByTenderIdDocument,
          variables: { tenderId: Number(tenderID) },
        },
      ]
      : [],
  });

  return {
    deleteSheetAgentRunMutation,
    loading,
    error,
  };
}
